module.exports = __webpack_public_path__ + "img/mcct_long_logo01.0eb5217c.jpg";